import { gql } from '@apollo/client'

export const GET_SUPPORTED_CURRENCIES = gql`
  query getSupportedCurrencies {
    supportedCurrencies {
      supportedCurrencies {
        code
      }
    }
  }
`
